import { Text } from "@/ui";
import { t } from "@/utils";
import Dialog from "@/components/Dialog";

export default function DiscardDialog({
  isOpen,
  onClose,
  onDiscard
}: {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
}) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={t("dialog.discardChanges.heading")}
      body={<Text>{t("dialog.discardChanges.text")}</Text>}
      buttons={{
        cancel: { label: t("buttons.keep") },
        confirm: { label: t("discard"), color: "error" }
      }}
      onConfirm={() => {
        onClose();
        onDiscard();
      }}
    />
  );
}
